<mdc-dialog>
  <mdc-dialog-container>
    <mdc-dialog-surface>
      <mdc-dialog-title>Gjennomfør dagsoppgjør</mdc-dialog-title>
      <mdc-dialog-content>
        <div class="oppgjor__rapportdata" *ngIf="kassedata">
          <div class="oppgjor__rapportdata__row">
            <span>Inngående kassebeholdning</span
            ><span>kr {{ kassedata.inng_veksel }},-</span>
          </div>
          <div class="oppgjor__rapportdata__row">
            <span>Kontant salg/retur/innbetalinger:</span
            ><span>kr {{ kassedata.cash_salg_returer }},-</span>
          </div>
          <div class="oppgjor__rapportdata__row">
            <span>Forventet kassebeholdning:</span
            ><span>kr {{ kassedata.utg_veksel }},-</span>
          </div>
          <div class="oppgjor__rapportdata__row">
            <span>Avdeling:</span
            ><span
              >{{ kassedata.kasse?.avdeling?.nr }}
              {{ kassedata.kasse?.avdeling?.navn }}</span
            >
          </div>
        </div>
        <div>
          <mdc-text-field
            outlined
            class="w100"
            label="Opptalt kassebeholdning"
            type="number"
            [formControl]="belop_opptalt"
          ></mdc-text-field>
        </div>
        <div>
          <p>
            Differanse:
            <span *ngIf="belop_opptalt.value != null">{{ differanse }},-</span>
          </p>
        </div>
        <div *ngIf="differanse !== 0 && differanse !== null">
          <mdc-textarea
            outlined
            class="w100"
            label="Kommentar til differansen"
            [formControl]="diff_kommentar"
            rows="3"
          ></mdc-textarea>
          <mdc-helper-text persistent>Påkrevd ved differanse</mdc-helper-text>
        </div>
        <div>
          <mdc-text-field
            outlined
            class="w100"
            label="Antall fribilletter delt ut"
            type="number"
            [formControl]="fribillett_utdelt"
          ></mdc-text-field>
        </div>
        <div *ngIf="fribillett_utdelt.value > 0">
          <mdc-textarea
            outlined
            class="w100"
            label="Begrunnelse for utdelte fribilletter"
            [formControl]="fribillett_begrunnelse"
            rows="3"
          ></mdc-textarea>
          <mdc-helper-text persistent>Påkrevd når antall er høyere enn 0</mdc-helper-text>
        </div>
      </mdc-dialog-content>
      <mdc-dialog-actions>
        <button mdc-button class="button-no-bg" mdcDialogAction="close">
          Avbryt
        </button>
        <button
          mdc-button
          raised
          [disabled]="!kanLukke()"
          (click)="lukkKasse()"
        >
          Ja, lukk kasse
        </button>
      </mdc-dialog-actions>
    </mdc-dialog-surface>
  </mdc-dialog-container>
</mdc-dialog>
